import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
const resources = {
  fr: {
    translation: {
      // Common
      'common.loading': 'Chargement...',
      'common.error': 'Une erreur est survenue',
      'common.retry': 'Réessayer',
      'common.back': 'Retour',
      'common.save': 'Enregistrer',
      'common.cancel': 'Annuler',
      'common.delete': 'Supprimer',
      'common.edit': 'Modifier',
      'common.view': 'Voir',
      'common.search': 'Rechercher',
      'common.filter': 'Filtrer',
      'common.sort': 'Trier',
      'common.all': 'Tous',
      'common.none': 'Aucun',
      'common.yes': 'Oui',
      'common.no': 'Non',
      'common.success': 'Succès',
      'common.failure': 'Échec',
      'common.continue': 'Continuer',
      'common.previous': 'Précédent',
      'common.next': 'Suivant',
      'common.finish': 'Terminer',
      
      // Products
      'products.title': 'Nos Produits',
      'products.subtitle': 'Découvrez notre gamme de motos électriques',
      'products.noProducts': 'Aucun produit trouvé',
      'products.filter.all': 'Tous les produits',
      'products.filter.moto': 'Motos électriques',
      'products.filter.accessory': 'Accessoires',
      'products.filter.part': 'Pièces détachées',
      'products.price': 'Prix',
      'products.features': 'Caractéristiques',
      'products.specifications': 'Spécifications',
      'products.reviews': 'Avis clients',
      'products.financing': 'Options de financement',
      'products.related': 'Produits similaires',
      'products.addToFavorites': 'Ajouter aux favoris',
      'products.removeFromFavorites': 'Retirer des favoris',
      'products.share': 'Partager',
      'products.download': 'Télécharger la fiche technique',
      'products.trial': 'Essai gratuit',
      'products.order': 'Commander',
      
      // Stations
      'stations.title': 'Nos Stations',
      'stations.subtitle': 'Trouvez une station de recharge près de chez vous',
      'stations.noStations': 'Aucune station trouvée',
      'stations.filter.all': 'Toutes les stations',
      'stations.filter.available': 'Disponibles',
      'stations.filter.maintenance': 'En maintenance',
      'stations.search': 'Rechercher une station',
      'stations.navigate': 'Y aller',
      'stations.details': 'Détails',
      'stations.status.available': 'Disponible',
      'stations.status.busy': 'Occupée',
      'stations.status.maintenance': 'En maintenance',
      'stations.chargingPoints': 'Points de charge',
      'stations.openingHours': 'Horaires d\'ouverture',
      'stations.contact': 'Contact',
      'stations.address': 'Adresse',
      'stations.distance': 'Distance',
      
      // Contact
      'contact.title': 'Contactez-nous',
      'contact.subtitle': 'Nous sommes à votre écoute',
      'contact.form.name': 'Nom complet',
      'contact.form.email': 'Email',
      'contact.form.phone': 'Téléphone',
      'contact.form.subject': 'Sujet',
      'contact.form.message': 'Message',
      'contact.form.submit': 'Envoyer',
      'contact.form.success': 'Votre message a été envoyé avec succès',
      'contact.form.error': 'Une erreur est survenue lors de l\'envoi de votre message',
      'contact.offices': 'Nos bureaux',
      'contact.faq': 'Questions fréquentes',
      'contact.social': 'Réseaux sociaux',
      'contact.newsletter': 'Newsletter'
    }
  },
  en: {
    translation: {
      // Common
      'common.loading': 'Loading...',
      'common.error': 'An error occurred',
      'common.retry': 'Retry',
      'common.back': 'Back',
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.view': 'View',
      'common.search': 'Search',
      'common.filter': 'Filter',
      'common.sort': 'Sort',
      'common.all': 'All',
      'common.none': 'None',
      'common.yes': 'Yes',
      'common.no': 'No',
      'common.success': 'Success',
      'common.failure': 'Failure',
      'common.continue': 'Continue',
      'common.previous': 'Previous',
      'common.next': 'Next',
      'common.finish': 'Finish',
      
      // Products
      'products.title': 'Our Products',
      'products.subtitle': 'Discover our range of electric motorcycles',
      'products.noProducts': 'No products found',
      'products.filter.all': 'All products',
      'products.filter.moto': 'Electric motorcycles',
      'products.filter.accessory': 'Accessories',
      'products.filter.part': 'Spare parts',
      'products.price': 'Price',
      'products.features': 'Features',
      'products.specifications': 'Specifications',
      'products.reviews': 'Customer reviews',
      'products.financing': 'Financing options',
      'products.related': 'Related products',
      'products.addToFavorites': 'Add to favorites',
      'products.removeFromFavorites': 'Remove from favorites',
      'products.share': 'Share',
      'products.download': 'Download datasheet',
      'products.trial': 'Free trial',
      'products.order': 'Order',
      
      // Stations
      'stations.title': 'Our Stations',
      'stations.subtitle': 'Find a charging station near you',
      'stations.noStations': 'No stations found',
      'stations.filter.all': 'All stations',
      'stations.filter.available': 'Available',
      'stations.filter.maintenance': 'Under maintenance',
      'stations.search': 'Search for a station',
      'stations.navigate': 'Navigate',
      'stations.details': 'Details',
      'stations.status.available': 'Available',
      'stations.status.busy': 'Busy',
      'stations.status.maintenance': 'Under maintenance',
      'stations.chargingPoints': 'Charging points',
      'stations.openingHours': 'Opening hours',
      'stations.contact': 'Contact',
      'stations.address': 'Address',
      'stations.distance': 'Distance',
      
      // Contact
      'contact.title': 'Contact Us',
      'contact.subtitle': 'We are here to help',
      'contact.form.name': 'Full name',
      'contact.form.email': 'Email',
      'contact.form.phone': 'Phone',
      'contact.form.subject': 'Subject',
      'contact.form.message': 'Message',
      'contact.form.submit': 'Send',
      'contact.form.success': 'Your message has been sent successfully',
      'contact.form.error': 'An error occurred while sending your message',
      'contact.offices': 'Our offices',
      'contact.faq': 'Frequently asked questions',
      'contact.social': 'Social media',
      'contact.newsletter': 'Newsletter'
    }
  }
};

// Initialize i18next with error handling
try {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'fr',
      fallbackLng: 'fr',
      interpolation: {
        escapeValue: false
      }
    })
    .catch((error) => {
      console.error('i18n initialization error:', error);
    });
} catch (error) {
  console.error('i18n initialization failed:', error);
}

export default i18n;